import { render, staticRenderFns } from "./OnDemand.vue?vue&type=template&id=6b0df4fa&scoped=true&"
import script from "./OnDemand.vue?vue&type=script&lang=js&"
export * from "./OnDemand.vue?vue&type=script&lang=js&"
import style0 from "./OnDemand.vue?vue&type=style&index=0&id=6b0df4fa&scoped=true&lang=scss&"
import style1 from "./OnDemand.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0df4fa",
  null
  
)

export default component.exports